import { render } from "./settings-assets.vue?vue&type=template&id=d5715b06"
import script from "./settings-assets.vue?vue&type=script&lang=js"
export * from "./settings-assets.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__